import { ca } from '@cian/analytics';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../../types/analytics';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { IBetPosition } from '../../../../../../../types/reducers/betPosition';

interface ITrackChangeServiceParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  activeServiceId: EServiceId;
  bet: number | null;
  betPosition: IBetPosition | null;
}

export const trackChangeService = ({
  analyticsOfferStatus,
  analyticsProduct,
  activeServiceId,
  bet,
  betPosition,
}: ITrackChangeServiceParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_change_vas',
    label: activeServiceId,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest_koeff',
        bid: bet,
        position: betPosition?.offerPosition,
        page_number: betPosition?.page,
      },
    },
  });
};
